(ns hai.web-app.theme
  "Radix Theme support

  Provides a dark/light theme switch, with initial value the system value, and
  which updates with the system value.
  "
  (:require
   [hai.ui.components :as c]
   [hai.ui.icons :as icons]
   [hai.web-app.util.rf-storage :as rf-storage]
   [hai.ui.rf-sugar :refer [<s >e >e! defevent defevent-fx defsub defeffect]]
   [lambdaisland.ornament :as o]))

(defevent :theme/set-dark-mode
  <-> [(rf-storage/settings-local)]
  [db enable]
  (assoc db :theme/dark-mode enable))

(defsub :theme/dark-mode [db]
  (:theme/dark-mode db))

(o/defstyled dark-mode-switch :div
  [:>div :flex :items-center :gap-2 :p-2]
  [:svg {:fill c/--gray-indicator}]
  ([]
   [:div
    [icons/filled-wb_sunny]
    [c/Switch {:checked @(<s :theme/dark-mode)
               :on-checked-change #(>e [:theme/set-dark-mode %])}]
    [icons/filled-mode_night]]))

(defevent-fx :theme/init
  <-> [(rf-storage/settings-local)]
  [{:keys [db]}]
  db
  (if (nil? (:theme/dark-mode db))
    {:db db
     :theme/init true
     :theme/listener true}
    {:db db
     :theme/listener true}))

(defeffect :theme/init [_]
  (when js/window.matchMedia
    (when (.-matches (js/window.matchMedia "(prefers-color-scheme: dark)"))
      (>e [:theme/set-dark-mode true]))))

(defeffect :theme/listener [_]
  (when js/window.matchMedia
    (.addEventListener (js/window.matchMedia "(prefers-color-scheme: dark)")
                       "change"
                       (fn [e]
                         (>e! [:theme/set-dark-mode (.-matches e)])))))

(defn init! []
  (>e! [:theme/init]))
